import { string } from 'yup';
import { FormBase } from '@quatrecentquatre/form-me';

export class CompatibilityLeadForm extends FormBase {
    constructor(options) {
        super(options);
        //set default variables

        this.addFields([
            {
                name: 'fields[form_email]',
                validationSchema: string().email().required(),
                $error: this.$el.querySelector('[name="fields[form_email]"]').parentElement.querySelector('.error-msg'),
            },
            {
                name: 'fields[form_phone]',
                validationSchema: string(),
                $error: this.$el.querySelector('[name="fields[form_phone]"]').parentElement.querySelector('.error-msg'),
            },
            {
                name: 'fields[form_geographical_sector]',
                validationSchema: string().required(),
                $error: this.$el
                    .querySelector('[name="fields[form_geographical_sector]"]')
                    .parentElement.querySelector('.error-msg'),
            },
        ]);
    }

    initialize() {
        super.initialize();
        this.button = this.$el.querySelector('button[type="submit"]');

        this.$el.classList.remove('hide');
    }

    /**
     * Scroll to error position. Query selector finds first error.
     */

    handleValidationError() {
        super.handleValidationError();

        const overlayWrapper = document.querySelector('#overlay-check-compatibility > .wrapper');
        if (overlayWrapper) {
            // Scroll to position of error.
            const targetElement = this.$el.querySelector('.has-error');
            const { top } = targetElement.getBoundingClientRect();
            const targetOffset = overlayWrapper.scrollY + top - 200;

            overlayWrapper.scroll({
                top: targetOffset,
                behavior: 'smooth',
            });
        }
    }

    handleAjaxSend(e) {
        this.button.disabled = true;
        this.addLoader();

        super.handleAjaxSend(e);
    }

    ajaxError(error) {
        this.$el.parentElement.querySelector('.success-message').classList.add('hide');
        this.$el.classList.add(this.classes.serverError);
        this.$el.querySelector('.error-message').innerText = this.$el
            .querySelector('.error-message')
            .getAttribute('data-default');
        this.$el.querySelector('.error-message').classList?.remove('hide');
    }

    ajaxSuccess(response) {
        if (response.success) {
            // Push to GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'contact-compatibility-form-submit',
                product_name: document.getElementById('product-name-overlay-compat').value,
            });

            // Reset form
            this.$el.reset();

            // Remove has-value classes from all form fields
            let hasValue = this.$el.querySelectorAll('.has-value');
            if (hasValue) {
                hasValue.forEach((entry) => {
                    entry.classList.remove('has-value');
                });
            }

            // Hide form
            this.$el.classList.add('hide');

            // Show success message, hide error if visible
            this.$el.parentElement.querySelector('.success-message').classList?.remove('hide');
            this.$el.querySelector('.error-message').classList?.add('hide');
        } else {
            // Show error message, hide success if visible
            this.$el.parentElement.querySelector('.success-message').classList?.add('hide');
            this.$el.querySelector('.error-message').innerText = response.errors[0];
            this.$el.querySelector('.error-message').classList?.remove('hide');
        }
    }

    ajaxComplete() {
        super.ajaxComplete();
        this.removeLoader();

        // Enable submit button
        this.button.disabled = false;
    }

    resetFieldState(field) {
        // Remove has-error from field
        super.resetFieldState(field);
        if (field.$targetErrorClass) {
            field.$targetErrorClass.classList.remove(this.classes.error);
        }
    }
    setFieldState(field, error) {
        // Remove has-error to parent field (used for $targetErrorClass at line 22)
        super.setFieldState(field, error);
        if (field.$targetErrorClass) {
            field.$targetErrorClass.classList.add(this.classes.error);
        }
    }

    addLoader() {
        const lang = document.querySelector('html').getAttribute('lang');
        const loaderText = lang === 'fr' ? 'Chargement...' : lang === 'pt' ? 'Carregando...' : 'Loading...';

        const spinnerWrapper = document.createElement('div');
        spinnerWrapper.className = 'spinner-wrapper';
        const loader = document.createElement('span');
        loader.className = 'loader';
        loader.innerText = loaderText;

        spinnerWrapper.appendChild(loader);

        this.$el.appendChild(spinnerWrapper);
    }

    removeLoader() {
        this.$el.parentNode.querySelector('.spinner-wrapper')?.remove();
    }
}

Me.forms['CompatibilityLeadForm'] = CompatibilityLeadForm;
